import { useContext, useRef } from "react";
import { AbortError, validationFailed, ValidationResult, validationSuccessful } from "sprint-common-web";

import { useBucketArchiveApi } from "../api/useBucketArchiveApi";
import { BucketArchiveListingContext } from "../context/BucketArchiveListingContext";
import { ImportArchiveBucketFormInputs } from "./ImportArchiveBucketForm";

export const useImportArchiveBucketForm = () => {
    const { validateBucketArchiveUniqueId: validateId, importBucketArchive } = useBucketArchiveApi();

    const { addBucketArchiveItem } = useContext(BucketArchiveListingContext);

    const abortController = useRef<AbortController>(new AbortController());

    const validateUniqueId = async (uniqueId: string | undefined): Promise<ValidationResult> => {
        abortController.current.abort();
        abortController.current = new AbortController();

        if (uniqueId) {
            try {
                const response = await validateId(uniqueId, abortController.current.signal);

                if (!response.isValid) {
                    return validationFailed(response.failures);
                }
            } catch (error) {
                if (error instanceof AbortError) {
                    return validationSuccessful();
                }

                throw error;
            }
        }

        return validationSuccessful();
    };

    const addImportBucketArchive = async ({ uniqueId }: ImportArchiveBucketFormInputs) => {
        const response = await importBucketArchive({ uniqueId });

        if (response) {
            addBucketArchiveItem({ uniqueId, bucketName: response?.entityId });
        }
    };

    return {
        validateUniqueId,
        addImportBucketArchive
    };
};
